export const SIDEBAR_DETAILS='SIDEBAR_DETAILS';